module.exports = __webpack_public_path__ + "static/media/button-tick-success.fe64d1ee.svg";